module.exports = __webpack_public_path__ + "files/a32c81c65c2903e95b8a414f345831ae.png";